/// <amd-module name="Dashboards/CommonConfig/CombinedSizePicker" />
import * as Resources from "Dashboards/CommonConfig/Resources";
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { InlineError } from "./InlineError";
import { SizePickerProps } from "./SizePicker.props";
import { generateOptions } from "./SizePickerHelpers";
import { Dropdown } from "VSSUI/Dropdown";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

export class CombinedSizePicker extends VssComponent<SizePickerProps> {
    private selectionObj: DropdownSelection = new DropdownSelection();
    private options: IListBoxItem[];

    constructor(props: SizePickerProps) {
        super(props);
        this.options = generateOptions(this.props.sizes);
        const selectedValue = this.props.value && format(Resources.Size_ColumnXRow, this.props.value.columnSpan, this.props.value.rowSpan);
        const selectedKey = this.options.findIndex(size => size.id === selectedValue);
        this.selectionObj.select(selectedKey);
    }

    public render(): JSX.Element {
        const hasAtLeastOneOption = this.props.sizes.length > 1;
       
        return (
            <>
                {hasAtLeastOneOption && (
                    <>
                        
                        <div className="config-size-picker flex-column">
                            <label>{Resources.SizeControlLabel}</label>
                            <div className="flex-column">
                            <Dropdown
                                className="config-size-picker"
                                ariaLabel={Resources.SizeControlLabel}
                                items={this.options}
                                onSelect={this.onChange}
                                selection={this.selectionObj}
                                showFilterBox={false}
                            />
                                <InlineError />
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }

    private onChange = (event?: any, item?: IListBoxItem): void => {
        const selectedEntry = item != null ? item : null;

        if (selectedEntry) {
            const selectedKey = this.options.findIndex(size => size.id === selectedEntry.id);
            this.selectionObj.select(selectedKey);
            this.props.onChange(this.props.sizes[selectedKey]);
        }
    };
}

